<template>
<div>

    <div v-if="cstore.getShip.wait" class="CruisePage__ifloader"><Loader class="CruisePage__loader" /></div>
    <template v-if="cstore.getShip.ok"><Ship :ship="cstore.getShip.resolve.ship" :roomDetail="cstore.getShip.resolve.roomDetail"></Ship></template>
    <div v-if="cstore.getShip.reject">! не удалось</div>


</div>
</template>

<script setup>
import Ship from '@/comp/Ship/Ship.vue'
import {ref, watch} from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
import useCruiseStore from '@/cstore.js'
import Loader from '@/comp/Loader/Loader.vue'

const route = useRoute()
const cstore=useCruiseStore()



watch( 
    ()=> route.query.id,
    () => {
        const { id } = route.query
        cstore.loadShip({id})
    },
    { immediate: true }
)


</script>
